import { syncAction } from '@/lib/action';

import type { GridLayout } from '@/domain/documents/gridPreset/schemas';
import type { SavedColumnLayout } from '@/domain/documents/savedColumnLayout';

// The Documents workspace grid layout. "External" actions change the working layout from outside the grid and bump
// the slice's revision, which makes the grid apply it (one `api.setState`). `gridStateReported` comes from the grid
// itself and never bumps, so a reported change is not applied back.

export type GridPresetResolvedPayload = {
  companyId: string;
  presetId: string;
  sharedPresetId: string | null;
  saved: GridLayout;
  current: GridLayout;
  // Default's columns, kept for the presets menu and for presets saved without columns.
  defaultColumns: SavedColumnLayout;
  // false when the presets list failed to load: the grid opens with Default, but the stored choice is not
  // overwritten, so the next load restores it.
  persist?: boolean;
};

export const gridPresetResolvedAction = syncAction<GridPresetResolvedPayload>('DOCUMENTS_GRID_PRESET/RESOLVED');
// `current` becomes `saved`. The shared entry leaves the menu unless the shared preset is the one chosen.
export const gridPresetChosenAction = syncAction<{ presetId: string; saved: GridLayout }>(
  'DOCUMENTS_GRID_PRESET/PRESET_CHOSEN',
);
export const gridPresetResetAction = syncAction('DOCUMENTS_GRID_PRESET/RESET');
// Filters written from outside the grid: chip removal, clear-all, the empty state's reset.
export const gridPresetFiltersSetAction = syncAction<Record<string, unknown>>('DOCUMENTS_GRID_PRESET/FILTERS_SET');
export const gridPresetGridStateReportedAction = syncAction<GridLayout>('DOCUMENTS_GRID_PRESET/GRID_STATE_REPORTED');
// A preset was saved from the working layout: it becomes the current preset, the working layout stays.
export const gridPresetSavedAction = syncAction<{ presetId: string; saved: GridLayout }>(
  'DOCUMENTS_GRID_PRESET/PRESET_SAVED',
);
export const gridPresetDefaultColumnsChangedAction = syncAction<SavedColumnLayout>(
  'DOCUMENTS_GRID_PRESET/DEFAULT_COLUMNS_CHANGED',
);
export const gridPresetClearedAction = syncAction('DOCUMENTS_GRID_PRESET/CLEARED');
